module.exports = __webpack_public_path__ + "static/media/Bela-Shah.c70a927d.png";